import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ActiveRecord, Record } from '../../models/record';
import { ResetStore, SetActiveRecord, SetActiveTab } from './user-list.actions';
import { UserListState } from './user-list.state';
import { ActiveRecordFacade } from '../core/active-record-facade';

@Injectable({
  providedIn: 'root',
})
export class UserListFacade implements ActiveRecordFacade {
  private readonly store = inject(Store);

  @Select(UserListState.activeRecord) activeRecord$: Observable<ActiveRecord | undefined>;
  @Select(UserListState.activeTab) activeTab$: Observable<number>;

  get activeRecord(): ActiveRecord | undefined {
    return this.store.selectSnapshot(UserListState.activeRecord);
  }

  get activeTab(): number {
    return this.store.selectSnapshot(UserListState.activeTab);
  }

  clearStore() {
    this.store.dispatch(new ResetStore());
  }

  setActiveRecord(record: Record, collectionId: number, selectedIndex: number) {
    this.store.dispatch(new SetActiveRecord({ ...record, collectionId, sliderIndex: selectedIndex }));
  }

  setActiveTab(index: number) {
    this.store.dispatch(new SetActiveTab(index));
  }
}
